import { DefaultService } from '@/services/DefaultService';

export default class FlexLancamentoService extends DefaultService {
    findAll(filtros) {
        return this._http
            .post(encodeURI(`${this._env}/flexLancamento.json`), filtros, this._headers)
            .then(
                (res) => {
                    return res.body;
                },
                (err) => {
                    this.handleError(err);
                }
            );
    }

    findAllBloqueados(filtros) {
        return this._http
            .post(encodeURI(`${this._env}/flexLancamento/findAllBloqueados.json`), filtros, this._headers)
            .then(
                (res) => {
                    return res.body;
                },
                (err) => {
                    this.handleError(err);
                }
            );
    }

    find(uuid) {
        return this._http
            .get(`${this._env}/flexLancamento/uuid/${uuid}.json`, this._headers)
            .then(
                (res) => {
                    return res.body;
                },
                (err) => {
                    this.handleError(err);
                }
            );
    }

    save(form) {
        return this._http
            .post(
                `${this._env}/flexLancamento/criarLancamento.json`,
                form,
                this._headers
            )
            .then(
                (res) => {
                    return res.body;
                },
                (err) => {
                    this.handleError(err);
                }
            );
    }

    movimentaSaldo(form) {
        return this._http
            .post(
                `${this._env}/flexLancamento/movimentaSaldo.json`,
                form,
                this._headers
            )
            .then(
                (res) => {
                    return res.body;
                },
                (err) => {
                    this.handleError(err);
                }
            );
    }

    findAllTotais(filtros) {
        return this._http
            .post(encodeURI(`${this._env}/flexLancamento/findAllTotais.json`), filtros, this._headers)
            .then(
                (res) => {
                    return res.body;
                },
                (err) => {
                    this.handleError(err);
                }
            );
    }

    findAllItensTotal(filtros) {
        return this._http
            .post(encodeURI(`${this._env}/flexLancamento/findAllItensTotal.json`), filtros, this._headers)
            .then(
                (res) => {
                    return res.body;
                },
                (err) => {
                    this.handleError(err);
                }
            );
    }
}
